import React, { MouseEvent } from 'react';
import { FakeDropdownBox } from './fake-dropdown-box';
import { FilterPopper } from './filter-popper';

type Props = {
  placeholder: string;
  openPopper: boolean;
  anchorEl: HTMLDivElement | null;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
  onClose: () => void;
} & React.PropsWithChildren;

export function FilterDropdown(props: Props) {
  const { children, placeholder, openPopper, anchorEl, onClick, onClose } =
    props;

  return (
    <>
      <FakeDropdownBox onClick={onClick}>{placeholder}</FakeDropdownBox>
      <FilterPopper
        open={openPopper}
        anchorEl={anchorEl}
        placement='bottom-start'
        onClose={onClose}
      >
        {children}
      </FilterPopper>
    </>
  );
}
